<template>
    <template v-for="subcat in category.children_recursive" :key="subcat.id">
      <option :value="subcat.id">
        {{ dot }}{{ subcat?.user?.name }}
      </option>
      <SubSupervisors
        v-if="subcat.children_recursive && subcat.children_recursive.length > 0"
        :category="subcat"
        :dot="dot + '----'"
      ></SubSupervisors>
    </template>
  </template>
  
  <script>
  export default {
    props: {
      category: {
        type: Object,
        required: true,
      },
      dot: {
        type: String,
        default: "",
      },
    },
  };
  </script>
  